import { createSelector } from 'reselect';
import { AUTH_STATUSES } from 'auth/types';
import { RootState } from 'store/configureStore';

const getStatus = (state: RootState) => state.auth.status;

export const getIsLogging = (state: RootState) => state.auth.isLogging;

export const getIsLoggedIn = createSelector([getStatus], (status) => status === AUTH_STATUSES.AUTHENTICATED);
